var map = {
	"./first_bg.png": 710,
	"./first_bg_2.png": 711,
	"./first_bg_3.png": 712,
	"./first_bg_4.png": 713,
	"./first_bg_5.png": 714,
	"./first_bg_6.png": 715
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1861;